import * as React from "react";
import Svg, { Path } from "react-native-svg";

const BloodFilledIcon = (props) => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.495 3.25H8.5a.75.75 0 000 1.5h.26v5.087a7.25 7.25 0 01-1.256 4.078l-3.093 4.548a1.855 1.855 0 001.326 2.887l.087.01.017.002c4.093.46 8.225.46 12.318 0l.018-.002.086-.01a1.855 1.855 0 001.326-2.887l-3.093-4.548a7.25 7.25 0 01-1.256-4.078V4.75h.26a.75.75 0 000-1.5h-1.005zm-4.666 9.3h4.342a8.75 8.75 0 01-.43-2.713V4.75H10.26v5.087c0 .927-.147 1.842-.431 2.713zM10 17a1 1 0 100 2 1 1 0 000-2zm2-1a1 1 0 112 0 1 1 0 01-2 0z"
        fill="#001533"
      />
    </Svg>
  );
};

export default BloodFilledIcon;
